var version = {
    "name":      "dativery",
    "buildDateCode": "20251119-122706",
    "buildDate": "Wed Nov 19 2025 12:27:06 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251119-122706",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;